module.exports = __webpack_public_path__ + "img/exam-online-exam-title.e464edea.png";